import { render } from "./TabSwiper.vue?vue&type=template&id=422605ee&scoped=true"
import script from "./TabSwiper.vue?vue&type=script&lang=js"
export * from "./TabSwiper.vue?vue&type=script&lang=js"

import "./TabSwiper.vue?vue&type=style&index=0&id=422605ee&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-422605ee"]])

export default __exports__